module.exports = __webpack_public_path__ + "img/status.ef19f97d.svg";